// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash-usab {
  width: 100%;
  min-width: 0;
  margin-top: 8px;
}

.dash-usab-header {
  margin-bottom: 16px;
}

.dash-usab-title {
  margin: 0;
  font-size: clamp(1.05rem, 2.4vw, 1.3rem);
  font-weight: 700;
  color: #f3f4f6;
}

.dash-usab-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.dash-usab-error {
  margin: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.12);
  color: #fca5a5;
  font-size: 14px;
}

.dash-usab-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.dash-usab-card {
  background: #111;
  border: 1px solid #374151;
  border-radius: 10px;
  padding: 14px 16px 16px;
  min-width: 0;
  box-sizing: border-box;
}

.dash-usab-card-title {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
}

.dash-usab-footnote,
.dash-usab-empty {
  margin: 12px 0 0;
  font-size: 12px;
  color: #9ca3af;
}

.dash-usab-bars {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dash-usab-bar-row {
  display: grid;
  grid-template-columns: minmax(72px, 28%) minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.dash-usab-bar-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dash-usab-bar-track {
  height: 10px;
  background: #1f2937;
  border-radius: 999px;
  overflow: hidden;
  min-width: 0;
}

.dash-usab-bar-fill {
  height: 100%;
  border-radius: 999px;
  min-width: 2px;
  transition: width 0.35s ease;
}

.dash-usab-bar-value {
  font-size: 12px;
  font-weight: 600;
  color: #f3f4f6;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

@media (max-width: 420px) {
  .dash-usab-bar-row {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
  }

  .dash-usab-bar-label {
    grid-column: 1 / -1;
  }

  .dash-usab-bar-value {
    grid-column: 2;
    grid-row: 2;
  }

  .dash-usab-bar-track {
    grid-column: 1;
    grid-row: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/xtamDashboard/DashboardUsabilityCharts.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":[".dash-usab {\n  width: 100%;\n  min-width: 0;\n  margin-top: 8px;\n}\n\n.dash-usab-header {\n  margin-bottom: 16px;\n}\n\n.dash-usab-title {\n  margin: 0;\n  font-size: clamp(1.05rem, 2.4vw, 1.3rem);\n  font-weight: 700;\n  color: #f3f4f6;\n}\n\n.dash-usab-subtitle {\n  margin: 6px 0 0;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.dash-usab-error {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: rgba(239, 68, 68, 0.12);\n  color: #fca5a5;\n  font-size: 14px;\n}\n\n.dash-usab-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));\n  gap: 16px;\n  width: 100%;\n  min-width: 0;\n}\n\n.dash-usab-card {\n  background: #111;\n  border: 1px solid #374151;\n  border-radius: 10px;\n  padding: 14px 16px 16px;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.dash-usab-card-title {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e7eb;\n}\n\n.dash-usab-footnote,\n.dash-usab-empty {\n  margin: 12px 0 0;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.dash-usab-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dash-usab-bar-row {\n  display: grid;\n  grid-template-columns: minmax(72px, 28%) minmax(0, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  min-width: 0;\n}\n\n.dash-usab-bar-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dash-usab-bar-track {\n  height: 10px;\n  background: #1f2937;\n  border-radius: 999px;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.dash-usab-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  min-width: 2px;\n  transition: width 0.35s ease;\n}\n\n.dash-usab-bar-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #f3f4f6;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n@media (max-width: 420px) {\n  .dash-usab-bar-row {\n    grid-template-columns: 1fr auto;\n    grid-template-rows: auto auto;\n  }\n\n  .dash-usab-bar-label {\n    grid-column: 1 / -1;\n  }\n\n  .dash-usab-bar-value {\n    grid-column: 2;\n    grid-row: 2;\n  }\n\n  .dash-usab-bar-track {\n    grid-column: 1;\n    grid-row: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
